module.exports = __webpack_public_path__ + "static/media/AW_HP_FR_766x844_Lemonade.4da85579.jpg";